module.exports = __webpack_public_path__ + "img/whispers_of_wood-hero_v2.208670d.webp";